import classificationTypes from "keys/classificationTypes"


const transliteration = "transliteration"
const query = "query"
const brain = "brain"
const details = "details"
const login = "login"
const cut = "cut"
const uploadAudio = "upload-audio"
const assessment = "assessment"
const rating = "rating"
const uploadAudioFile = "create-upload-assessment"
const words = "words"
const createAssessmentRecord = "create-assessment-record"
const matchingLearning = "matching-learning"
const assessmentVersions = "assessment-versions"
const trainingAssessmentComparison = "training-assessment-comparison"
const assessmentDefs = "assessment-defs"
const adminAssessments = "admin-assessments"
const manageAssessments = "manage-assessments"
const assessmentExecutionTracking = "assessment-execution-tracking"
const assessmentExecution = "assessment-execution"
const assessmentsStatus = "assessments-results-tracking"
const testTakers = "test-takers"
const assessments = "assessments"
const transcription = "transcription"
const assessmentCosts = "assessment-costs"
const tutorial1 = "general"
const tutorial2 = "students"
const tutorial3 = "assessments"
const tutorial4 = "reports"
const register1 = "1"
const register2 = "2"
const register3 = "3"
const register4 = "4"
const reset1 = "1"
const reset2 = "2"
const reset = "reset"
const recoverUsername = "recover-username"
const thankYou = "thank-you"
const manage = "manage"

const performAssessments = "perform-assessments"
const practiceAssessments = "practice-assessments"
const micCheck = "mic-check"
const createPracticeAssessments = "create-practice-assessments"
const audioTranscription = "audio-transcription"
const createAssessments = "create-assessments"
const createBattery = "create-battery"
const createAssessment = "create-assessment"
const dashboard = "home"
const affiliationSetup = "affiliation-setup"
const payments = "payments"
const contactUs = "contact-us"
const markingWords = "marking-words"
const markingTrainingWords = "marking-training-words"
const audioCutting = "audio-cutting"
const assessmentDef = "assessment-def"
const assessmentView = "assessment-view"
const makingRecordAssessments = "making-record-assessments"
const learningResources = "learning-resources"
const linguisticLab = "linguistic-lab"
const childDevelopment = "child-development"
const assessmentLibrary = "assessment-library"
const tutorials = "tutorials"
const normalizer = "normalizer"
const users = "users"
const affiliations = 'affiliations'
const school = "school"
const user = "user"
const newsletter = "newsletter"
const newsletters = "newsletters"
const textReadability = "text-readability"
const wordReadability = "word-readability"
const tickets = 'tickets'
const selectRole = "select-role"
const schoolRegistartion = "school-registartion"
const achievementGraph = "achievement-graph"
const primaryAssessments = 'primary-assessments'
const trainingDuplicateAssessments = 'training-duplicate-assessments'
const progressGraphs = "progress-graphs"
const unregisterUser = "unregister-user"
const loginSuccess = "login-success"
const systemReview = "system-review"
const stuckReasons = "stuck-reasons"

const app = {
    app: '/',
    users: `/${users}`,
    unregisterUser: `/${unregisterUser}`,
    login: `/${login}`,
    loginSuccess: `/${loginSuccess}`,
    rating: `/${rating}`,
    progressGraphs: `${systemReview}/${progressGraphs}`,
    createAssessment: `/${createAssessment}`,
    testTakers: `/${testTakers}`,
    assessments: `/${assessments}`,
    affiliations: `/${affiliations}`,
    affiliationById: `/${affiliations}/:affiliationID`,
    createAffiliation: `/${affiliations}/new`,
    assessmentsById: `/${assessments}/:assessmentID`,
    assessmentDefsById: `/${assessmentDefs}/:assessmentDefID`,
    adminAssessmentById: `/${adminAssessments}/:assessmentID`,
    assessmentDefs: `/${assessmentDefs}`,
    assessment: `/${assessment}`,
    selectRole: `/${selectRole}`,
    schoolRegistartion: `/${schoolRegistartion}`,
    assessmentById: `/${assessment}/:assessmentID`,
    matchingLearning: `/${matchingLearning}`,
    assessmentVersions: `/${assessmentVersions}/:assessmentID`,
    matchingLearningById: `/${matchingLearning}/:assessmentID`,
    createAssessmentRecordById: `/${createAssessmentRecord}/:testTakerID`,
    createAssessmentRecord: `/${createAssessmentRecord}`,
    createAssessments: `/${createAssessments}`,
    createBattery: `/${createBattery}`,
    createPracticeAssessments: `/${createPracticeAssessments}`,
    contactUs: `/${contactUs}`,
    performAssessments: `/${performAssessments}`,
    practiceAssessments: `/${practiceAssessments}`,
    micCheck: `/${micCheck}`,
    assessmentExecutionTracking: `/${systemReview}/${assessmentExecutionTracking}`,
    assessmentExecution: `/${systemReview}/${assessmentExecution}`,
    assessmentsStatus: `/${systemReview}/${assessmentsStatus}`,
    assessmentDef: `/${assessmentDef}`,
    uploadAudioFile: `/${uploadAudioFile}`,
    uploadAudioFileById: `/${uploadAudioFile}/:testTakerID`,
    adminAssessments: `/${adminAssessments}`, 
    manageAssessments: `/${manageAssessments}`,
    markingWords: `/${markingWords}`,
    markingTrainingWords: `/${markingTrainingWords}`,
    assessmentLibrary: `/${assessmentLibrary}`,
    assessmentView: `/${assessmentView}`,
    assessmentViewById: `/${assessmentView}/:assessmentID`,
    makingRecordAssessments: `/${makingRecordAssessments}`,
    learningResources: `/${learningResources}`,
    transcription: `/${transcription}`,
    audioCuttingAssessments: `/${manage}/${audioCutting}`,
    markingWordsAssessments: `/${manage}/${primaryAssessments}`,
    markingTrainingWordsAssessments: `/${manage}/${trainingDuplicateAssessments}`,
    transcriptionAssessments: `/${manage}/${transcription}`,
    assessmentCosts: `/${manage}/${assessmentCosts}`,
    transcriptionById: `/${manage}/${transcription}/:assessmentID`,
    audioCuttingById: `/${manage}/${audioCutting}/:assessmentID`,
    markingWordsById: `/${manage}/${markingWords}/:assessmentID`,
    audioTranscription: `/${audioTranscription}`,
    linguisticLab: `/${linguisticLab}`,
    audioCutting: `/${audioCutting}`,
    register: "/register",
    register1: `/register/${register1}`,
    register2: `/register/${register2}`,
    register3: `/register/${register3}`,
    register4: `/register/${register4}`,
    reset1: `/reset/${reset1}`,
    dashboard: `/${dashboard}`,
    payments: `/${payments}`,
    emailSignature: "/email-signature",
    reset: `/${reset}`,
    recoverUsername: `/${recoverUsername}`,
    thankYou: `/${thankYou}`,
    textReadability: `/${linguisticLab}/${textReadability}/`,
    wordReadability: `/${linguisticLab}/${wordReadability}/`,
    childDevelopment: `/${childDevelopment}`,
    normalizer: `/${childDevelopment}/${normalizer}/`,
    newsletter: `/${newsletter}/`,
    newsletters: `/${newsletters}`,
    createNewsletter: `/${newsletters}/new`,
    createUser: `/${users}/new`,
    editUser: `/${users}/:userID`,
    editNewsletter: `/${newsletters}/:newsletterID/edit/`,
    newslettersById: `/${newsletters}/:newsletterID`,
    tutorials: `/${tutorials}/`,
    tutorial1: `/${tutorials}/general`,
    tutorial2: `/${tutorials}/students/`,
    tutorial3: `/${tutorials}/assessments/`,
    tutorial4: `/${tutorials}/reports/`,
    achievementGraph: `${systemReview}/${achievementGraph}/`,
    createAssessmentDef: `/${assessmentLibrary}/new`,
    editAssessmentDef: `/${assessmentLibrary}/:assessmentDefID`,
    performAssessmentById: `/${performAssessments}/:assessmentID`,
    performPracticesAssessmentById: `/${practiceAssessments}/:assessmentID`,
    performAssessmentPreviewById: `/${performAssessments}/:assessmentID/preview/`,
    audioTranscriptionById: `/${audioTranscription}/:assessmentID`,
    tickets: `/${tickets}`,
    ticketById: `/${tickets}/:ticketID`,
    school: `/school`,
    affiliationSetup: `/${affiliationSetup}`,
    stuckReasons: `/${stuckReasons}`
}

export { stuckReasons, createBattery, systemReview, createPracticeAssessments, practiceAssessments, micCheck, loginSuccess, affiliationSetup, affiliations, school, trainingAssessmentComparison, trainingDuplicateAssessments, primaryAssessments, markingTrainingWords, progressGraphs, achievementGraph, assessmentExecution, assessmentExecutionTracking, assessmentsStatus, assessmentVersions, user, assessmentLibrary, tickets, wordReadability, performAssessments, tutorial1, tutorial2, tutorial3, tutorial4, tutorials, newsletter, newsletters, normalizer, textReadability, childDevelopment, users, contactUs, manage, thankYou, payments, dashboard, register1, recoverUsername, reset1, register2, reset2, register4, register3, transcription, assessmentCosts, linguisticLab, audioTranscription, audioCutting, learningResources, makingRecordAssessments, assessmentView, markingWords, manageAssessments, adminAssessments, uploadAudioFile, assessmentDef, createAssessments, app, createAssessment, assessments, testTakers, assessmentDefs, createAssessmentRecord, matchingLearning, words, assessment, rating, uploadAudio, cut, transliteration, query, brain, details, login }
